export default __webpack_public_path__ + "static/uCall x Spa_page-0001-332427a7580929e71ca7de040023d71d.jpg";